import loading from '@/utils/loading.json'
import * as rewardProductCategoriesApi from '@/services/reward-product-categories.js'
import history from '@/common/data/jsonData'
import { getHistoryList } from '@/services/resource'
import createTable from '@/components/createTable'
import viewFrame from '@/components/viewFrame'
import customeTable from '@/components/customeTable'
import dialogEffect from '@/components/dialogEffect'
import jsonData from './jsonData'
export default {
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect
  },
  data () {
    return {
      validateVisible: false,
      buttonObj: [],
      titleObject: {},
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      basicViewItem: jsonData.basicViewItem,
      historyTableItem: history.historyTableItem,
      dialogData: [],
      batchData: [],
      dialogVisible: false,
      historyTableData: []
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  mounted () {
    const _this = this
    _this.init()
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = _this.$loading(loading) : _this.$store.state.app.loading.close()
    },
    // 初始化
    init () {
      const _this = this
      _this.setGlobalLoading(true)
      rewardProductCategoriesApi.getId(_this.urlParams.id).then(res => {
        _this.setGlobalLoading(false)
        _this.custName = res.data.reward_product_category
        Object.assign(_this.titleObject, { title: '', data: '' })
      }).catch(() => _this.setGlobalLoading(false))
      //  获取历史操作
      getHistoryList({ item_type: 'RewardProductCategory', item_id: _this.urlParams.id }).then(res => {
        if (res.status === 200) {
          this.historyTableData = res.data.versions
        }
      })
    },
    handleEditClick () {
      this.$router.push({
        name: 'rewardsStoreProductCategoriesEdit',
        params: {
          id: this.$route.params.id
        }
      })
    }
  }
}
